// Coordonnees lues depuis /public/config.js (window.SITE_CONFIG), modifiable
// directement sur le serveur sans rebuild. Valeurs ci-dessous = secours si absent.
const cfg = (typeof window !== "undefined" && window.SITE_CONFIG) || {};

export const PHONE_DISPLAY = cfg.phoneDisplay || "06 25 25 86 19";
export const PHONE_TEL = `tel:${cfg.phoneTel || "+33625258619"}`;
export const PHONE_FIXE_DISPLAY = cfg.phoneFixeDisplay || "01 84 21 07 67";
export const PHONE_FIXE_TEL = `tel:${cfg.phoneFixeTel || "+33184210767"}`;
export const EMAIL = cfg.email || "semifermeture75@gmail.com";
export const WHATSAPP_URL = `https://wa.me/${cfg.whatsappNumber || "33625258619"}?text=${encodeURIComponent(
    cfg.whatsappMessage || "Bonjour, j'ai besoin d'un serrurier en urgence à Paris."
)}`;

export const IMG = (name) => `https://www.serrurierparis.paris/img/${name}`;

export const SERVICES = [
    {
        slug: "/ouverture-de-porte",
        icon: "icones/ouverture-porte.webp",
        title: "Ouverture de porte",
        price: "60€ TTC",
        desc: "Porte claquée, bloquée ou fermée à clé ? Ouverture sans casse par un artisan qualifié, en moins de 5 minutes pour une porte claquée.",
    },
    {
        slug: "/changement-de-serrure",
        icon: "icones/changement-serrure.webp",
        title: "Changement de serrure",
        price: "dès 85€",
        desc: "Remplacement et entretien de serrures toutes marques, de la serrure 3 points à la serrure 7 points. Justificatif de domicile demandé.",
    },
    {
        slug: "/porte-blindee",
        icon: "icones/porte-blindee.webp",
        title: "Porte blindée & blindage",
        price: "sur devis",
        desc: "Conseil, installation et sécurisation de portes blindées adaptées à votre logement et à votre budget.",
    },
    {
        slug: "/rideau-metallique",
        icon: "icones/rideau-metallique.webp",
        title: "Rideau métallique",
        price: "sur devis",
        desc: "Installation, fabrication, dépannage, déblocage et ouverture de rideaux métalliques pour commerces et locaux professionnels.",
    },
    {
        slug: "/coffre-fort",
        icon: "icones/coffre-fort.webp",
        title: "Coffre-fort",
        price: "dès 150€",
        desc: "Ouverture et installation de coffres-forts. Une protection maximale, pensée pour durer dans le temps.",
    },
    {
        slug: "/double-de-cle",
        icon: "icones/double-clef.webp",
        title: "Double de clé",
        price: "dès 5€",
        desc: "Reproduction rapide de clés de qualité : clé plate 5€, clé à gorges 11€, clé spéciale à partir de 35€.",
    },
];

export const TARIFS = [
    { service: "Ouverture de porte simple claquée", price: "60€", note: "TTC, intervention comprise" },
    { service: "Ouverture de porte simple fermée à clé", price: "60€", note: "TTC, intervention comprise" },
    { service: "Ouverture de porte blindée claquée", price: "60€", note: "TTC, intervention comprise" },
    { service: "Changement de serrure / cylindre", price: "85€", note: "main d'œuvre, total sur devis" },
    { service: "Serrure multipoint / réglage de porte", price: "135€", note: "main d'œuvre, total sur devis" },
    { service: "Double de clé", price: "5€", note: "clé à gorges 11€, spéciale dès 35€" },
    { service: "Coffre-fort", price: "150€", note: "ouverture, à partir de" },
    { service: "Blindage / porte blindée BP1-BP3", price: "sur devis", note: "étude gratuite" },
    { service: "Rideau métallique", price: "sur devis", note: "dépannage & fabrication" },
];

export const ARRONDISSEMENTS = Array.from({ length: 20 }, (_, i) => ({
    n: i + 1,
    label: `Paris ${i + 1}${i === 0 ? "er" : "e"}`,
    cp: `750${String(i + 1).padStart(2, "0")}`,
}));

export const FAQS = [
    {
        q: "Quel est le prix d'une ouverture de porte à Paris ?",
        a: "L'ouverture d'une porte simple claquée est facturée 60€ TTC, intervention comprise — y compris pour une porte blindée claquée ou une porte fermée à clé. Pour un changement de serrure, la main d'œuvre est de 85€ (135€ pour une serrure multipoint), le prix de la serrure étant défini sur devis gratuit. Aucune majoration cachée : le prix annoncé est le prix payé.",
    },
    {
        q: "En combien de temps un serrurier peut-il intervenir ?",
        a: "Nos artisans serruriers sont positionnés dans tout Paris et l'Île-de-France : nous intervenons en 20 à 30 minutes après votre appel, de jour comme de nuit. Pour une porte simplement claquée, l'ouverture elle-même prend généralement moins de 5 minutes.",
    },
    {
        q: "Intervenez-vous la nuit, le week-end et les jours fériés ?",
        a: "Oui. Notre service SOS Serrurier Paris fonctionne 24h/24 et 7j/7, y compris les samedis, dimanches et jours fériés. Des serruriers de garde répondent à toutes vos sollicitations : perte de clés, porte claquée, cambriolage.",
    },
    {
        q: "Vos tarifs sont-ils vraiment transparents ?",
        a: "Absolument. Tout devis est gratuit et sans engagement. Au-delà de 150€ de travaux, un devis écrit est obligatoire et vous est systématiquement remis, même sans le demander. En urgence, nous établissons un devis/facture détaillant chaque dépense : main d'œuvre et pièces.",
    },
    {
        q: "Êtes-vous agréé par les assurances ?",
        a: "Oui, notre entreprise de serrurerie est agréée par la majorité des compagnies d'assurance. Nos prestations sont conformes à leurs exigences, ce qui facilite votre remboursement après une ouverture de porte ou un cambriolage.",
    },
    {
        q: "Faut-il un justificatif pour un changement de serrure ?",
        a: "Oui. Pour tout changement de serrure, notre artisan vous demandera un justificatif de domicile. C'est une mesure de sécurité indispensable qui vous protège, notamment après un déménagement.",
    },
    {
        q: "Quelles marques de serrures remplacez-vous ?",
        a: "Nos serruriers montent et changent toutes les marques et tous les types de serrures : Fichet, Bricard, JPM, Vachette, DOM, Reelax… Serrures 3 à 7 points, cylindres, verrous, gâches électriques, sur portes bois, PVC, aluminium ou blindées.",
    },
    {
        q: "Quelles zones couvrez-vous ?",
        a: "Nous intervenons dans les 20 arrondissements de Paris (75001 à 75020) et dans toute l'Île-de-France : 77, 78, 91, 92, 93, 94 et 95. Appartements, bureaux, commerces, immeubles, locaux industriels et hôtels.",
    },
    {
        q: "Comment éviter les arnaques en serrurerie ?",
        a: "Méfiez-vous d'un serrurier qui propose immédiatement de tout changer : si votre serrure est réparable, un artisan honnête vous le dira. Exigez toujours un devis précis avant les travaux et vérifiez que les coordonnées de l'entreprise figurent sur le devis et la facture. En cas de doute, demandez un deuxième avis.",
    },
    {
        q: "Que faire après un cambriolage ?",
        a: "Nous intervenons en urgence pour sécuriser votre logement : ouverture, réparation ou remplacement de la serrure endommagée, blindage si nécessaire. Pour gagner du temps, vous pouvez déposer une pré-plainte en ligne auprès de la police nationale avant notre arrivée.",
    },
    {
        q: "Ma clé est cassée dans la serrure — que faire ?",
        a: "Ne forcez pas davantage : chaque tentative pousse le fragment plus profond dans le cylindre. Appelez-nous immédiatement. Nous disposons d'extracteurs spécialisés (crochet et hélicoïde) pour retirer le morceau sans démonter la serrure dans la grande majorité des cas. Si le cylindre est endommagé, nous le remplaçons dans la même intervention.",
    },
    {
        q: "Comment fonctionne le crochetage de serrure ?",
        a: "Le crochetage consiste à manipuler les goupilles du cylindre avec des outils fins (crochet et outil de tension) pour reproduire l'action d'une clé sans en posséder une. C'est une technique non destructive applicable sur les cylindres standard. Les cylindres haute sécurité (A2P BP2/BP3) intègrent des goupilles serpiginées et des billes anti-crochetage qui rendent la manipulation impossible — le perçage devient alors nécessaire.",
    },
    {
        q: "Peut-on poser une porte blindée sur n'importe quel encadrement ?",
        a: "Dans la majorité des cas, oui. Nos techniciens effectuent une étude gratuite à domicile pour vérifier la compatibilité de l'encadrement (bâti bois, béton ou métal), l'épaisseur du mur et les jours disponibles. Si l'huisserie existante ne peut pas recevoir une porte blindée, nous proposons une pose complète avec remplacement de l'encadrement.",
    },
    {
        q: "Mon rideau métallique est bloqué la nuit — intervenez-vous ?",
        a: "Oui, 24h/24 et 7j/7. Un rideau bloqué la nuit expose votre commerce ou votre local. Nos techniciens déblocage rideau métallique interviennent en urgence pour rétablir l'accès ou sécuriser la fermeture dans la nuit même.",
    },
    {
        q: "Quelle est la différence entre un cylindre A2P BP1, BP2 et BP3 ?",
        a: "La certification A2P (Assurance Prévention Protection) classe les cylindres selon leur résistance à l'effraction en laboratoire : BP1 résiste 10 minutes, BP2 résiste 20 minutes, BP3 résiste 30 minutes. Plus le niveau est élevé, plus les techniques (crochetage, perçage, arrachage) sont difficiles à appliquer. La plupart des assureurs exigent au minimum un cylindre A2P BP1 pour la garantie vol.",
    },
    {
        q: "Combien coûte un double de clé pour une serrure Fichet ?",
        a: "Les clés Fichet sont protégées par brevet et ne peuvent être reproduites que sur présentation de la carte de propriété. Le tarif d'un double dépend du modèle : entre 35 € et 90 € selon la génération (Fichet F3D, Fichet Radial, etc.). Sans carte de propriété, le remplacement du cylindre avec un nouveau jeu de clés est la solution la plus rapide.",
    },
    {
        q: "Combien de temps une serrure dure-t-elle avant de nécessiter un remplacement ?",
        a: "Une serrure de qualité dure en moyenne 15 à 20 ans si elle est entretenue (graissage annuel de la gâche et des pênes avec une graisse sèche au PTFE). Les signaux qui indiquent un remplacement prochain : clé qui tourne avec résistance, pêne qui sort difficilement, bruit anormal. Un entretien préventif coûte moins cher qu'un dépannage d'urgence.",
    },
    {
        q: "Puis-je obtenir un devis sans me déplacer ?",
        a: "Oui. Appelez-nous au 06 25 25 86 19 : nos opérateurs qualifient votre situation et vous donnent une estimation tarifaire par téléphone. Pour les interventions complexes (blindage, coffre-fort, rideau métallique), un déplacement gratuit de diagnostic est proposé afin d'établir un devis écrit précis sans engagement.",
    },
];

export const REVIEWS = [
    {
        name: "Karim B.",
        place: "Paris 15e",
        text: "Porte claquée un dimanche soir, serrurier arrivé en 20 minutes. Ouverture sans casse et prix annoncé au téléphone respecté. Je recommande vivement.",
    },
    {
        name: "Sophie L.",
        place: "Paris 11e",
        text: "Devis clair avant l'intervention, aucune surprise sur la facture. Travail soigné pour le changement de notre serrure 3 points. Artisan sérieux et ponctuel.",
    },
    {
        name: "Marc D.",
        place: "Boulogne-Billancourt",
        text: "Après un cambriolage, intervention rapide et porte sécurisée le soir même. Une équipe rassurante et très professionnelle dans un moment difficile.",
    },
];

export const LOCK_BRANDS = ["JPM", "Bricard", "Fichet", "Vachette", "DOM", "Reelax"];
export const INSURANCES = ["MAAF", "MACIF", "Allianz", "AXA", "GMF", "Groupama", "AGF"];

export const LOCKSMITH_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Locksmith",
    name: "Serrurier Paris",
    image: "https://www.serrurierparis.paris/img/logo-serrurierparis.webp",
    description:
        "Artisan serrurier à Paris et Île-de-France. Ouverture de porte, changement de serrure, blindage, rideau métallique. Dépannage 24h/24 et 7j/7, intervention en 30 minutes, devis gratuit.",
    url: "https://www.serrurierparis.paris/",
    telephone: "+33625258619",
    priceRange: "€€",
    openingHours: "Mo-Su 00:00-24:00",
    areaServed: ["Paris", "Île-de-France"],
    address: {
        "@type": "PostalAddress",
        addressLocality: "Paris",
        addressRegion: "Île-de-France",
        addressCountry: "FR",
    },
};
